export default __webpack_public_path__ + "static/media/buildings.15ea067f.svg";